import axios from "axios";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import "./ClientsOverview.css";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ThreeDots } from "react-loader-spinner";
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Countries from "../../constants/countries";
import userTypeConsts from '../../constants/userTypeConsts';
import { useSelector, useDispatch } from "react-redux";
import Plus from "../../images/icons/plus-black.svg";
import PlusIcon from "../../images/icons/plus-icon.svg";
import InviteIcon from "../../images/icons/invite.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import dletImage from "../../images/singleinvoice/delete.svg";
import addicon from "../../images/icons/addicon.svg";
import DownloadImage from "../../images/icons/download-icon.svg";
import EyeIcon from "../../images/icons/eye-icon.svg";
import EyeCrossed from "../../images/icons/eye-crossed.svg";
import { setNotification } from "../../features/notification/notificationSlice.js";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { logout, reset } from "../../features/auth/authSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import ClientsOverviewListing from "./ClientsOverviewListing";
import {
  useClientPendingInvitesCount,
  useFetchClientDetails,
  useFetchClientExportDetails,
} from "../TimeTracker/TimeTrackerClient/useClientDetails.jsx";
import { useFetchProjectManager } from "../TimeTracker/TimeTrackerProject/useProjectDetails.jsx";
import HeaderActions from "./Actions/HeaderActions.jsx"
import SortMenu from "./Actions/SortMenu.jsx"

const ClientOverviewSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientName, setClientName] = useState("");
  const [legalEntityName, setLegalEntityName] = useState("");
  const [shortName, setShortName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [accManager, setAccManager] = useState("");
  const [accManagerDropdownOpen, setAccManagerDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [accManagerIsValid, setAccManagerIsValid] = useState(false);
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyLogoName, setCompanyLogoName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [updateClientList, setUpdateClientList] = useState(false);
  const [countrySearchTerm, setCountrySearchTerm] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [stateSearchTerm, setStateSearchTerm] = useState("");
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [filter, setFilter] = useState("");
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isCliInviteModalOpen, setIsCliInviteModalOpen] = useState(false);
  const [cliInvEmail, setCliInvEmail] = useState("");
  const [cliInvEmails, setCliInvEmails] = useState([]);
  const [alreadySentCliInvEmailsList, setAlreadySentCliInvEmailsList] = useState([]);
  const [isResendCliInviteModalOpen, setIsResendCliInviteModalOpen] = useState(false);
  const [isCliInvMailLoading, setIsCliInvMailLoading] = useState(false);
  const [isBulkImportModalOpen, setIsBulkImportModalOpen] = useState(false);
  const [isBulkImportLoading, setIsBulkImportLoading] = useState(false);
  const [bulkImportFile, setBulkImportFile] = useState(null);
  const [bulkImportFileName, setBulkImportFileName] = useState("");
  const accManagerRef = useRef(null);
  const accManagerSelectDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const countryDropdownRef = useRef(null);
  const stateDropdownRef = useRef(null);
  const passwordRef = useRef(null);
  const passwordConfirmationRef = useRef(null);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [checkedOption, setCheckedOption] = useState(null);
  const sortDropdownRef = useRef(null);

  let token = null;
  const { user } = useSelector((state) => state.auth);
  const { appSettings } = useSelector((state) => state.appSettings);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }
  const { data: userIds = [] } = useFetchProjectManager(token);
  const { data: clientPendingInvitesCount = 0, isLoading: pendingInvitesCountLoading, refetch: refetchPendingInvitesCount, } = useClientPendingInvitesCount(token);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setClientName("");
    setEmail("");
    setMobileNo("");
    setAccManager("");
    setUserSearchTerm("");
    setAccManagerDropdownOpen(false);
    setAccManagerIsValid(false);
    setCompanyWebsite("");
    setCompanyLogo(null);
    setCompanyLogoName("");
    setCountry("");
    setState("");
    setAddress("");
    setAdditionalInfo("");
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCompanyLogo(e.target.files[0]);
      setCompanyLogoName(file.name);
    } else {
      setCompanyLogo(null);
      setCompanyLogoName("");
    }
  };

  useEffect(() => {
    dispatch(setHeaderText("Client Overview"));
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [dispatch]);

  const handleToggleAccManagerDropdown = () => {
    setUserSearchTerm("");
    setAccManagerDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleSelectAccManager = (selectedAccManager) => {
    setAccManager(selectedAccManager);
    setUserSearchTerm("");
    setAccManagerDropdownOpen(false);
  };

  const handleAccManagerSearchInputChange = (e) => {
    setUserSearchTerm(e.target.value);
  };


  const filteredUsers = userIds.filter((user) => {
    const fullName = user.first_name
      ? `${user.first_name} ${user.middle_name || ""} ${user.last_name}`
      : `${user.company_first_name
        ? user.company_first_name +
        (user.company_last_name && user.company_last_name)
        : user.company_name
      }`;
    return fullName?.toLowerCase().includes(userSearchTerm?.toLowerCase());
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      const sortedCountries = Countries.slice().sort((a, b) =>
        a.country.localeCompare(b.country)
      );
      setCountriesList(sortedCountries);
    }, 100); // Delay for non-blocking behavior (adjust delay as needed)

    // Cleanup the timer if dependencies change
    return () => clearTimeout(timer);
  }, []);

  const handleToggleCountryDropdown = () => {
    setCountrySearchTerm("");
    setCountryDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleCountrySearchInputChange = (e) => {
    setCountrySearchTerm(e.target.value);
  };

  const filteredCountries = countriesList.filter((country) => {
    return country.country
      ?.toLowerCase()
      .includes(countrySearchTerm?.toLowerCase());
  });

  const countryData = countriesList.find((c) => c.country === country);
  const states = countryData?.states || [];

  const handleStateSearchInputChange = (e) => {
    setStateSearchTerm(e.target.value);
  };

  const selectedCountry = countriesList.find((c) => c.country === country);
  const filteredStates = selectedCountry?.states?.filter((stateObj) =>
    stateObj.state.toLowerCase().includes(stateSearchTerm.toLowerCase())
  );

  const handleToggleStateDropdown = () => {
    setStateSearchTerm("");
    setStateDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideCountryDropdown =
      countryDropdownRef.current &&
      countryDropdownRef.current.contains(event.target);
    const isClickInsideStateDropdown =
      stateDropdownRef.current
      && stateDropdownRef.current.contains(event.target);
    const isClickInsideSortDropdown =
      sortDropdownRef.current && sortDropdownRef.current.contains(event.target);
    const isClickInsideStatusDropdown =
      statusDropdownRef.current &&
      statusDropdownRef.current.contains(event.target);
    const isClickInsideAccManagerSelectDropdown =
      accManagerSelectDropdownRef.current &&
      accManagerSelectDropdownRef.current.contains(event.target);

    if (!isClickInsideCountryDropdown) {
      setCountryDropdownOpen(false);
    }
    if (!isClickInsideStateDropdown) {
      setStateDropdownOpen(false);
    }
    if (!isClickInsideSortDropdown) {
      setSortDropdownOpen(false);
    }
    if (!isClickInsideStatusDropdown) {
      setStatusDropdownOpen(false);
    }
    if (!isClickInsideAccManagerSelectDropdown) {
      setAccManagerDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const toggleStatusDropdown = () => {
    setStatusDropdownOpen(!statusDropdownOpen);
  };
  const selectStatusOption = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
    setStatusDropdownOpen(false);
  };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) {
  //       setSortDropdownOpen(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const handleCliInviteSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmails = cliInvEmails.every(
      (obj) => !obj.cliInvEmail || emailRegex.test(obj.cliInvEmail)
    );
    if (!isValidEmails) {
      toast.error("Please enter valid email addresses!!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handleCloseCliInviteModal();
      return;
    }
    var allCliInvEmails = cliInvEmails;
    if (cliInvEmail !== "") {
      allCliInvEmails = [
        ...cliInvEmails,
        { cliInvEmail: cliInvEmail, id: Date.now() },
      ];
    }
    if (!cliInvEmail) {
      toast.error("Email cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (allCliInvEmails.some((obj) => !obj.cliInvEmail)) {
      toast.error("Email cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    try {
      setIsCliInvMailLoading(true);
      const response = await fetch("/api/client-invite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          cliInvEmails: allCliInvEmails.map((obj) => obj.cliInvEmail),
          invite_status: "0",
        }),
      });
      const data = await response.json();
      setCliInvEmails([]);
      setCliInvEmail("");
      setIsCliInviteModalOpen(false);
      if (response.ok) {
        if (
          data.alreadySentCliInvEmails.length > 0 ||
          data.alreadyRegisteredCliInvEmails.length > 0
        ) {
          const alreadySentCliInvEmails =
            data.alreadySentCliInvEmails.join(", ");
          const alreadyRegisteredCliInvEmails =
            data.alreadyRegisteredCliInvEmails.join(", ");
          const successSentCliInvEmails =
            data.successSentCliInvEmails.join(", ");
          if (alreadySentCliInvEmails) {
            setAlreadySentCliInvEmailsList(data.alreadySentCliInvEmails);
            const sentCliInvEmailsList = data.alreadySentCliInvEmails
              .map((entry) => entry)
              .join(", ");
            handleOpenResendCliInviteModal();
            toast.warning(
              `Invitation already sent to ${sentCliInvEmailsList}`,
              {
                position: "bottom-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
          }
          if (alreadyRegisteredCliInvEmails) {
            toast.warning(
              `User with email ${alreadyRegisteredCliInvEmails} is already registered`,
              {
                position: "bottom-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
          }
          if (successSentCliInvEmails) {
            dispatch(setNotification(Date.now()));
            toast.success(
              `Invitation successfully sent to ${successSentCliInvEmails}`,
              {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
            global.config.activityLog(
              window.location.href,
              "User Invite",
              `Invitation successfully sent to ${successSentCliInvEmails}`
            );
          }
        } else {
          const successSentCliInvEmails =
            data.successSentCliInvEmails.join(", ");
          dispatch(setNotification(Date.now()));
          toast.success("Mail sent successfully!", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          global.config.activityLog(
            window.location.href,
            "User Invite",
            `Invitation successfully sent to ${successSentCliInvEmails}`
          );
        }
      } else {
        toast.error("Failed to send mail.", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      toast.error("Something went wrong", { position: "bottom-right", autoClose: 2000 });
    } finally {
      setIsCliInvMailLoading(false);
      refetchPendingInvitesCount();
      handleCloseCliInviteModal();
    }
  };

  const handleResendCliInvEmails = async () => {
    try {
      setIsCliInvMailLoading(true);
      const response = await fetch("/api/client/resend-invitations", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          cliInvEmails: alreadySentCliInvEmailsList, // List of emails to resend
        }),
      });

      if (response.ok) {
        // Handle success
        // Close the resend modal
        setIsResendCliInviteModalOpen(false);
        // Show a success message
        toast.success("Invitations resent successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "User Invite",
          `Invitation successfully resent to ${alreadySentCliInvEmailsList}`
        );
      } else {
        // Handle failure
        // Show an error message
        toast.error("Failed to resend invitations.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      // Handle network or server error
      // Show an error message
      global.config.slackMessage(error.toString());
      toast.error("Failed to resend invitations.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsCliInvMailLoading(false);
      handleCloseResendCliInviteModal();
    }
  };

  const handleAddCliInvEmail = (e) => {
    e.preventDefault();
    // if (email !== "") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidCliInvEmails = emailRegex.test(cliInvEmail);
    if (cliInvEmail && !isValidCliInvEmails) {
      toast.error("Please enter valid email addresses!!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    // if (email) {
    const newCliInvEmailEntry = { cliInvEmail: cliInvEmail, id: Date.now() };
    setCliInvEmails([...cliInvEmails, newCliInvEmailEntry]);
    // }
    setCliInvEmail("");
    // }
  };

  const handleEditCliInvEmail = (id, field, value) => {
    const index = cliInvEmails.findIndex((obj) => obj.id === id);
    if (index !== -1) {
      const updatedCliInvEmails = [...cliInvEmails];
      updatedCliInvEmails[index] = { ...updatedCliInvEmails[index], [field]: value };
      setCliInvEmails(updatedCliInvEmails);
    }
  };

  const handleRemoveCliInvEmail = (id) => {
    const filteredCliInvEmails = cliInvEmails.filter((obj) => obj.id !== id);
    setCliInvEmails(filteredCliInvEmails);
  };

  const handleRemoveLatestCliInvEmail = () => {
    if (cliInvEmails.length === 0) return;
    const updatedCliInvEmails = [...cliInvEmails];
    const lastCliInvEmail = updatedCliInvEmails.pop();
    setCliInvEmails(updatedCliInvEmails);
    setCliInvEmail(lastCliInvEmail.cliInvEmail);
  };

  // Function to remove an email from the list
  const handleRemoveResendCliInvEmail = (cliInvEmailToRemove) => {
    const updatedCliInvEmails = alreadySentCliInvEmailsList.filter(
      (cliInvEmail) => cliInvEmail !== cliInvEmailToRemove
    );
    setAlreadySentCliInvEmailsList(updatedCliInvEmails);
  };

  const handleOpenResendCliInviteModal = () => {
    // Set the list of already sent emails here
    setIsResendCliInviteModalOpen(true);
  };

  const handleCloseResendCliInviteModal = () => {
    setIsResendCliInviteModalOpen(false);
    refetchPendingInvitesCount();
    setAlreadySentCliInvEmailsList([]);
  };

  const handleOpenCliInviteModal = () => {
    setIsCliInviteModalOpen(true);
  };

  const handleCloseCliInviteModal = () => {
    setIsCliInviteModalOpen(false);
    refetchPendingInvitesCount();
    setCliInvEmails([]);
    setCliInvEmail("");
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    setIsBulkImportLoading(true);
    if (!bulkImportFile) {
      toast.error("Please select a file.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsBulkImportLoading(false);
      return;
    }

    const maxFileSize = 5 * 1024 * 1024;
    if (bulkImportFile.size > maxFileSize) {
      toast.error("File size exceeds the 5 MB limit.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsBulkImportLoading(false);
      return;
    }

    const fileExtension = bulkImportFile.name.split(".").pop();
    if (fileExtension !== "xlsx") {
      toast.error("Only xlsx files are supported.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsBulkImportLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", bulkImportFile);

    try {
      const response = await axios.post("/api/bulk/import/client", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      const { status, message, existingClientEmails, duplicateEmails, insertedClients, skippedRows } = response.data;

      if (status === "requiredValidationError") {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        if (existingClientEmails && existingClientEmails.length > 0) {
          toast.error(
            `The following emails are already registered: ${existingClientEmails.join(", ")}`,
            {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }

        if (duplicateEmails && duplicateEmails.length > 0) {
          toast.error(
            `The following emails are already in use: ${duplicateEmails.join(", ")}`,
            {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }

        if (insertedClients && insertedClients.length > 0) {
          toast.success(`Inserted ${insertedClients.length} client records successfully!`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

        if (skippedRows && skippedRows.length > 0) {
          const skippedMessage = skippedRows.map((row) => {
            return `Row ${row.row}: ${row.reason}`;
          }).join(" | ");

          toast.warn(`Some rows were skipped: ${skippedMessage}`, {
            position: "bottom-right",
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        handleBulkImportCloseModal();
      }
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      toast.error("Error uploading file. Please try again.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsBulkImportLoading(false);
      setUpdateClientList((prevState) => !prevState);
    }
  };

  const handleBulkImportOpenModal = () => {
    setIsBulkImportModalOpen(true);
  };

  const handleBulkImportCloseModal = () => {
    setBulkImportFile(null);
    setBulkImportFileName("");
    setIsBulkImportModalOpen(false);
  };

  const handleBulkImportUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBulkImportFile(e.target.files[0]);
      setBulkImportFileName(file.name);
    } else {
      setBulkImportFile(null);
      setBulkImportFileName("");
    }
  };

  const toggleSortDropdown = () => {
    setSortDropdownOpen(!sortDropdownOpen);
  };

  const selectSortOption = (selectedOption) => {
    setSelectedSortOption(selectedOption);
    setCheckedOption(selectedOption); // Set the checked option
    setSortDropdownOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setAccManagerIsValid(false);
    setIsValidUrl(false);
    setPasswordMatchError("");
    setPasswordError("");
    const pattern = /^(ftp|http|https):\/\/[^ "]+$/;
    if (accManager === "" || clientName === "" || password === "" || passwordConfirmation === "") {
      if (accManager === "") {
        setAccManagerIsValid(true);
        accManagerRef && accManagerRef.current.focus();
        return;
      } else if (password === "") {
        setPasswordError("Password cannot be empty");
        passwordRef.current.focus();
        return;
      } else if (passwordConfirmation === "") {
        setPasswordMatchError("Confirm Password cannot be null");
        passwordConfirmationRef.current.focus();
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (!pattern.test(companyWebsite)) {
      toast.error("It's not a valid URL.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsValidUrl(true);
      setIsSubmitLoading(false);
      return;
    }
    if (password !== passwordConfirmation) {
      setPasswordMatchError("Passwords do not match");
      passwordConfirmationRef.current.focus();
      return;
    }
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!@#$%^&*()_+\-./:;<=>?@[\\\]^_`{|}~]{8,}$/;
    if (!passwordRegex.test(password)) {
      setPasswordError("Invalid password format");
      toast.error("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one digit and one special character from the set !@#$%^&*()_+,-/:;<=>?@_'[\\]{}|~", {
        position: "bottom-right",
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      passwordRef.current.focus();
      return;
    }
    const requestData = {
      client_name: clientName,
      legal_entity_name: legalEntityName,
      short_name: shortName,
      email,
      mobile_no: mobileNo,
      address,
      country,
      state,
      acc_manager: accManager,
      // contact_point: contactPoint,
      company_website: companyWebsite,
      password: password,
      additional_info: additionalInfo,
    };
    // Create a new FormData object
    const formData = new FormData();
    formData.append("company_logo", companyLogo);

    // Append the other request data to the form data
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }
    try {
      setIsSubmitLoading(true);
      const response = await axios.post(
        "/api/client-details/create",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data;
      if (data.status === "exists") {
        toast.error("Client already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success("Client registered successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleCloseModal();
        global.config.activityLog(
          window.location.href,
          "Client",
          `Client (${clientName}) Registered Successfully`
        );
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", { position: "bottom-right", autoClose: 2000 });
    } finally {
      setIsSubmitLoading(false);
      refetchClientProfiles();
      if (updateClientList === false) {
        setUpdateClientList(true);
      } else {
        setUpdateClientList(false);
      }
    }
  };

  const { data: clientProfiles = [], isLoading, refetch: refetchClientProfiles, } = useFetchClientDetails(token);
  const [exportEnabled, setExportEnabled] = React.useState(false);
  const { data: clientExportProfiles = [], refetch: refetchExport, isFetching: isExportFetching } = useFetchClientExportDetails(token, exportEnabled);

  const sortData = (data, selectedSortOption) => {
    switch (selectedSortOption) {
      case "By name: A - Z":
        return data
          .slice()
          .sort((a, b) => a.client_name.localeCompare(b.client_name));
      case "By name: Z - A":
        return data
          .slice()
          .sort((a, b) => b.client_name.localeCompare(a.client_name));
      case "Date: old to new":
        return data
          .slice()
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      case "Date: new to old":
        return data
          .slice()
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      default:
        return data;
    }
  };


  const sortedData = sortData(clientExportProfiles, selectedSortOption);

  const filteredData = sortedData.filter((item) => {
    const searchTerm = filter.trim()?.toLowerCase();
    if (!item.client_name?.toLowerCase().includes(searchTerm)) return false;
    if (selectedStatus === "Active") return item.is_active;
    if (selectedStatus === "Inactive") return !item.is_active;
    return true;
  });

  const exportToExcel = async () => {
    let rawData = clientExportProfiles;

    if (!exportEnabled || rawData.length === 0) {
      setExportEnabled(true);
      const result = await refetchExport();
      if (!result.data || result.data.length === 0) {
        toast.error("No data to export.", { position: "bottom-right", autoClose: 2000 });
        return;
      }
      rawData = result.data;
    }

    const searchTerm = filter.trim()?.toLowerCase();
    const exportData = sortData(rawData, selectedSortOption).filter((item) => {
      if (!item.client_name?.toLowerCase().includes(searchTerm)) return false;
      if (selectedStatus === "Active") return item.is_active;
      if (selectedStatus === "Inactive") return !item.is_active;
      return true;
    });

    if (exportData.length === 0) {
      toast.error("No data to export.", { position: "bottom-right", autoClose: 2000 });
      return;
    }

    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const modifiedLog = exportData.map((item, index) => ({
        SlNo: index + 1,
        "Commercial Name": item.client_name,
        "Legal Entity Name": item.legal_entity_name || "",
        Email: item.email || "",
        "Company Url": item.company_website || "",
        "Contact Number": item.mobile_no || "",
        Address: item.address || "",
        City: item.city || "",
        Country: item.country || "",
        Pincode: item.pincode || "",
        "Account Manager": item.acc_manager
          ? item.acc_manager?.first_name
            ? `${item.acc_manager.first_name} ${item.acc_manager.middle_name &&
              item.acc_manager.middle_name !== "null"
              ? item.acc_manager.middle_name + " "
              : ""
            }${item.acc_manager.last_name}`
            : item.acc_manager?.company_first_name
              ? `${item.acc_manager.company_first_name} ${item.acc_manager.company_last_name || ""
              }`
              : `${item.acc_manager?.company_name || ""} (Company)`
          : "",
        "Company VAT Number": item.vat_number || "",
        "Company VAT applicable Percentage": item.vat_percentage || "",
        "Billing Contact (Full Name)": item.billing_contact_name || "",
        "Billing Contact - Position": item.billing_contact_position || "",
        "Billing Contact - Email Address": item.billing_contact_email || "",
        "Preferred Currency": item.preferred_currency || "",
        "Preferred Payment Method": item.payment_method || "",
        "Signatory User Name": item.signatory_user_name || "",
        "Signatory User Email": item.signatory_email || "",
        "Signatory User Position": item.signatory_user_position || "",
        "Signatory Mobile-No": item.signatory_mobile_no || "",
        "Point of Contact User Name": item.poc_user_name || "",
        "Point of Contact Email": item.poc_email || "",
        "Point of Contact User Position": item.poc_user_position || "",
        "Additional Notes": item.additional_info || "",
        "Is Client Active": item.is_active ? "Yes" : "No",
        "Created At": moment(item.created_at)
          .tz(global.config.getTimeZone())
          .format("DD/MM/YYYY, hh:mm:ss A"),
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 25 }, // SlNo
        { wpx: 100 }, // Client_Name
        { wpx: 100 }, // Legal_Entity_Name
        { wpx: 175 }, // Email
        { wpx: 150 }, // Company_Website
        { wpx: 100 }, // Mobile_No
        { wpx: 200 }, // Address
        { wpx: 100 }, // City
        { wpx: 100 }, // Country
        { wpx: 100 }, // Pincode
        { wpx: 100 }, // Account_Manager
        { wpx: 100 }, // VAT_Number
        { wpx: 130 }, // VAT_Percentage
        { wpx: 150 }, // Billing_Contact_Name
        { wpx: 150 }, // Billing_Contact_Position
        { wpx: 175 }, // Billing_Contact_Email
        { wpx: 100 }, // Preferred_Currency
        { wpx: 100 }, // Payment_Method
        { wpx: 150 }, // Signatory_User_Name
        { wpx: 150 }, // Signatory_Email
        { wpx: 150 }, // Signatory_Position
        { wpx: 150 }, // Signatory_Mobile_No
        { wpx: 150 }, // POC_User_Name
        { wpx: 175 }, // POC_Email
        { wpx: 150 }, // POC_User_Position
        { wpx: 250 }, // Additional_Info
        { wpx: 100 }, // Is_Active
        // { wpx: 100 }, // Is_Invited
        { wpx: 200 }, // Created_At
      ];

      worksheet["!cols"] = colWidths;

      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      worksheet["!autofilter"] = { ref: range };
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          if (!worksheet[cellRef]) continue;
          if (colNum === 4 || colNum === 5 || colNum === 24) {
            worksheet[cellRef].s = {
              alignment: { wrapText: true, vertical: "top" },
            };
          } else {
            worksheet[cellRef].s = {
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients Log");
      XLSX.writeFile(
        workbook,
        `Clients_${formattedDate}_${formattedTime}.xlsx`
      );
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Clients Log",
        "Error occurred while exporting to Excel"
      );
      toast.error("Error occurred while exporting to Excel.", { position: "bottom-right", autoClose: 2000 });
    }
  };

  return (
    <div className="time-client-outer client-top-overview-outer changes-client">
      <div className="client-top-overview-name-btn">
        <div className="title-client-all">
          {global.config.locate(
            appSettings && appSettings.language,
            "Select a client"
          )}
        </div>
        <HeaderActions
          handleOpenCliInviteModal={handleOpenCliInviteModal}
          handleCloseCliInviteModal={handleCloseCliInviteModal}
          isCliInviteModalOpen={isCliInviteModalOpen}
          isCliInvMailLoading={isCliInvMailLoading}
          pendingInvitesCountLoading={pendingInvitesCountLoading}
          user={user}
          navigate={navigate}
          clientPendingInvitesCount={clientPendingInvitesCount}
          handleCliInviteSubmit={handleCliInviteSubmit}
          cliInvEmails={cliInvEmails}
          cliInvEmail={cliInvEmail}
          setCliInvEmail={setCliInvEmail}
          handleEditCliInvEmail={handleEditCliInvEmail}
          handleRemoveCliInvEmail={handleRemoveCliInvEmail}
          handleRemoveLatestCliInvEmail={handleRemoveLatestCliInvEmail}
          handleAddCliInvEmail={handleAddCliInvEmail}
          isResendCliInviteModalOpen={isResendCliInviteModalOpen}
          handleCloseResendCliInviteModal={handleCloseResendCliInviteModal}
          alreadySentCliInvEmailsList={alreadySentCliInvEmailsList}
          handleRemoveResendCliInvEmail={handleRemoveResendCliInvEmail}
          handleResendCliInvEmails={handleResendCliInvEmails}
          userTypeConsts={userTypeConsts}
          InviteIcon={InviteIcon}
          Modal={Modal}
          ThreeDots={ThreeDots}
          isExportFetching={isExportFetching}
          dletImage={dletImage}
          addicon={addicon}
          DownloadImage={DownloadImage}
          exportToExcel={exportToExcel}
          handleBulkImportOpenModal={handleBulkImportOpenModal}
          isBulkImportModalOpen={isBulkImportModalOpen}
          crssrImage={crssrImage}
          isBulkImportLoading={isBulkImportLoading}
          handleBulkImportCloseModal={handleBulkImportCloseModal}
          bulkImportFileName={bulkImportFileName}
          handleBulkImportUpload={handleBulkImportUpload}
          Plus={Plus}
          handleUpload={handleUpload}
          handleOpenModal={handleOpenModal}
          PlusIcon={PlusIcon}
          appSettings={appSettings}
          isModalOpen={isModalOpen}
          handleCloseModal={handleCloseModal}
          handleSubmit={handleSubmit}
          clientName={clientName}
          setClientName={setClientName}
          legalEntityName={legalEntityName}
          shortName={shortName}
          setShortName={setShortName}
          setLegalEntityName={setLegalEntityName}
          email={email}
          setEmail={setEmail}
          PhoneInput={PhoneInput}
          mobileNo={mobileNo}
          setMobileNo={setMobileNo}
          companyWebsite={companyWebsite}
          setCompanyWebsite={setCompanyWebsite}
          isValidUrl={isValidUrl}
          companyLogoName={companyLogoName}
          handleLogoUpload={handleLogoUpload}
          accManagerSelectDropdownRef={accManagerSelectDropdownRef}
          accManagerDropdownOpen={accManagerDropdownOpen}
          handleToggleAccManagerDropdown={handleToggleAccManagerDropdown}
          accManagerIsValid={accManagerIsValid}
          accManagerRef={accManagerRef}
          accManager={accManager}
          userIds={userIds}
          userSearchTerm={userSearchTerm}
          handleAccManagerSearchInputChange={handleAccManagerSearchInputChange}
          filteredUsers={filteredUsers}
          handleSelectAccManager={handleSelectAccManager}
          address={address}
          setAddress={setAddress}
          country={country}
          setCountry={setCountry}
          countryDropdownRef={countryDropdownRef}
          handleToggleCountryDropdown={handleToggleCountryDropdown}
          countryDropdownOpen={countryDropdownOpen}
          countrySearchTerm={countrySearchTerm}
          handleCountrySearchInputChange={handleCountrySearchInputChange}
          filteredCountries={filteredCountries}
          setCountryDropdownOpen={setCountryDropdownOpen}
          state={state}
          setState={setState}
          stateDropdownRef={stateDropdownRef}
          handleToggleStateDropdown={handleToggleStateDropdown}
          stateDropdownOpen={stateDropdownOpen}
          stateSearchTerm={stateSearchTerm}
          handleStateSearchInputChange={handleStateSearchInputChange}
          filteredStates={filteredStates}
          setStateDropdownOpen={setStateDropdownOpen}
          states={states}
          showPassword={showPassword}
          passwordError={passwordError}
          password={password}
          setPassword={setPassword}
          passwordRef={passwordRef}
          EyeCrossed={EyeCrossed}
          EyeIcon={EyeIcon}
          setShowPassword={setShowPassword}
          passwordMatchError={passwordMatchError}
          passwordConfirmation={passwordConfirmation}
          setPasswordConfirmation={setPasswordConfirmation}
          passwordConfirmationRef={passwordConfirmationRef}
          additionalInfo={additionalInfo}
          setAdditionalInfo={setAdditionalInfo}
          isSubmitLoading={isSubmitLoading}
        />
      </div>

      <div className="top-filter-client">
        <div className="top-filter-client-inner">
          <div className="top-filter-client-inner-left">
            <div className="top-filter-client-status">
              <label className="top-filter-client-status-label">Status</label>
              <div className="custom-dropdown">
                <div
                  ref={statusDropdownRef}
                  className={`custom-dropdown-user-new-outer custom-dropdown-select ${statusDropdownOpen ? "open" : ""}`}
                >
                  <div
                    className="selected-option custom-dropdown-user-new"
                    onClick={toggleStatusDropdown}
                  >
                    {selectedStatus
                      ? global.config.locate(
                        appSettings && appSettings.language,
                        selectedStatus
                      )
                      : appSettings && appSettings.language
                        ? global.config.locate(appSettings.language, "ALL")
                        : null}
                  </div>
                  {statusDropdownOpen && (
                    <div className="custom-dropdown-new">
                      <ul className="type-list">
                        <li onClick={() => selectStatusOption(null)}>All</li>
                        <li onClick={() => selectStatusOption("Active")}>
                          {global.config.locate(
                            appSettings && appSettings.language,
                            "Active"
                          )}
                        </li>
                        <li onClick={() => selectStatusOption("Inactive")}>
                          {global.config.locate(
                            appSettings && appSettings.language,
                            "Inactive"
                          )}
                        </li>
                        {/* Add more Status options as needed */}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="title-client-all-mobile">Select a Client</div>
            <div className="top-filter-client-search">
              <div className="search-sec">
                <div className="search-container">
                  <input
                    type="text"
                    className="search-input"
                    placeholder={global.config.locate(
                      appSettings && appSettings.language,
                      "Search"
                    )}
                    onChange={(e) => setFilter(e.target.value)}
                    value={filter}
                  />
                </div>
              </div>
            </div>
          </div>
          <SortMenu
            sortDropdownRef={sortDropdownRef}
            sortDropdownOpen={sortDropdownOpen}
            toggleSortDropdown={toggleSortDropdown}
            selectedSortOption={selectedSortOption}
            selectSortOption={selectSortOption}
            checkedOption={checkedOption}
            appSettings={appSettings}
          />
        </div>
      </div>

      <div className="client-ls-sec">
        <ClientsOverviewListing
          clientProfiles={clientProfiles}
          filter={filter}
          isLoading={isLoading}
          refetchClientProfiles={refetchClientProfiles}
          updateClientList={updateClientList}
          selectedSortOption={selectedSortOption}
          selectedStatus={selectedStatus}
        />
      </div>
    </div>
  );
};

export default ClientOverviewSection;
